import { createSlice } from '@reduxjs/toolkit';

const playMovieSlice = createSlice({
    name: 'playMovie',
    initialState: {
        playing: null,
        // { action, orderId } | null — an org-wide TMS control action is in
        // flight (broadcast via playback:lock); independent of `playing` since
        // an eject holds the lock while `playing` clears mid-flight.
        controlLock: null,
    },
    reducers: {
        setPlaying: (state, action) => {
            state.playing = action.payload;
        },
        clearPlaying: (state) => {
            state.playing = null;
        },
        setControlLock: (state, action) => {
            state.controlLock = action.payload;
        },
    },
});

export const { setPlaying, clearPlaying, setControlLock } = playMovieSlice.actions;

export default playMovieSlice.reducer;
